import NavBar from '../../../Components/NavBar'
import { AuthContextApi } from '../../../Context/api'
import { AuthContext } from '../../../Context'
import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { MagnifyingGlassCircleIcon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import Footer from '../../../Components/Footer'
import SpinnerOverlay from '../../../Components/SpinnerOverlay'
import moment from 'moment'
import NavMenu from '../../../Components/NavMenu/juridico'


const Juridico = () => {
    const { checkLogin, getJuridico, getJuridicoQuery } = useContext(AuthContextApi)
    const { states, setters } = useContext(AuthContext)
    const hist = useNavigate()
    const [searchQuery, setSearchQuery] = useState('')
    const [isSearching, setIsSearching] = useState(false)

    const isSigned = async () => {
        const response = await checkLogin()
        if (response === true) {

            setters.setSigned(true)
        } else {
            setters.setSigned(false)
        }
    }


    const load = async () => {
        await getJuridico()

    }

    const handleSearch = async (e) => {
        e.preventDefault()
        if (searchQuery.trim() === '') {
            handleClearSearch()
            return
        }

        setIsSearching(true)
        setters.setLimitSearchJuridico(false)
        await getJuridicoQuery(searchQuery.trim())
    }

    const handleClearSearch = async () => {
        setSearchQuery('')
        setIsSearching(false)
        setters.setOffsetJuridico(0)
        setters.setDataJuridico([])
        setters.setLimitSearchJuridico(false)
        await getJuridico()
    }

    const getProcessoPagina = async (id) => {
        hist(`/juridico/processos/${id}`)
    }

    useEffect(() => {
        setters.setLimitSearchJuridico(false)
        setters.setOffsetJuridico(0)
        isSigned()
        if (states.dataJuridico.length === 0) {
            load()
        }

        return () => {
            setters.setDataJuridico([])
            setters.setLimitSearchJuridico(false)
            setters.setOffsetJuridico(0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    useEffect(() => {
        if (isSearching && searchQuery && states.offsetJuridico > 0) {
            getJuridicoQuery(searchQuery.trim())
        } else if (!isSearching && states.offsetJuridico > 0) {
            load()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [states.offsetJuridico])

    return (
        <>
            <div className="flex flex-1 flex-col pb-16 bg-white">
                <NavBar />
                <div className="flex flex-1 items-center justify-center">
                    <SpinnerOverlay />

                    <div className='flex flex-1 flex-col md:pl-64 mb-4 mt-2'>
                        <div className="p-5 w-[100%] items-center justify-center">
                            {/* <NavMenu /> */}
                            <div className="flex flex-col px-4 sm:px-6 lg:px-8 border p-4 rounded-md">
                                <h1 className="text-[28px] font-semibold leading-6 text-gray-900">Jurídico</h1>
                                <p className="mt-2 text-lg text-gray-700">
                                    Olá! Abaixo estão listados os números dos seus processos.
                                </p>
                                <br />
                                <p className="mt-2 text-lg text-gray-700">
                                    Para acompanhar o andamento do seu processo,  busque o número do processo ou pelo nome, no campo de busca abaixo.
                                </p>
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="border p-5 rounded-md px-4 sm:px-6 lg:px-8">
                                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
                                    <h1 className="text-[24px] text-base font-semibold leading-6 text-gray-900 mb-4 sm:mb-0">Processos</h1>

                                    <form onSubmit={handleSearch} className="flex flex-1 sm:flex-initial gap-2 max-w-md">
                                        <div className="relative flex-1">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <input
                                                type="text"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                placeholder="Buscar processos..."
                                                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                            />
                                            {searchQuery && (
                                                <button
                                                    type="button"
                                                    onClick={handleClearSearch}
                                                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                                >
                                                    <XMarkIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                                                </button>
                                            )}
                                        </div>
                                        <button
                                            type="submit"
                                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                        >
                                            <MagnifyingGlassIcon className="h-5 w-5 mr-2" />
                                            Buscar
                                        </button>
                                    </form>
                                </div>

                                {isSearching && searchQuery && (
                                    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
                                        <p className="text-sm text-blue-800">
                                            Buscando por: <span className="font-semibold">"{searchQuery}"</span>
                                        </p>
                                        <button
                                            onClick={handleClearSearch}
                                            className="text-sm text-blue-600 hover:text-blue-800 font-medium underline"
                                        >
                                            Limpar busca
                                        </button>
                                    </div>
                                )}

                                <p className="mt-2 text-sm text-gray-700">
                                    {
                                        states.dataJuridico.length > 0 ? states.dataJuridico.map((item, index) => {
                                            return (
                                                <>
                                                    <div key={index} className="border p-4 my-2 flex flex-col sm:flex-row rounded-[10px] hover:shadow sm:items-between sm:justify-between">
                                                        <div className="flex flex-col ">
                                                            <p className="text-sm text-gray-700 mb-4">Nome da ação: {item.action_name}</p>
                                                            <div className="flex flex-row">
                                                                <div className="flex flex-col">
                                                                    <p className="text-sm text-gray-700">Número do processo: {item.number}</p>
                                                                    <p className="text-sm text-gray-700">Título do processo: {item.caseTitle}</p>
                                                                    <p className="text-sm text-gray-700">Atualizado em: {moment(item.process_updated_at).format('DD/MM/YYYY')}</p>
                                                                </div>
                                                                <div className="flex flex-col ml-12">
                                                                    <p className="text-sm text-gray-700">Nome do tribunal: {item.court}</p>
                                                                    <p className="text-sm text-gray-700">Vara: {item.vara}</p>
                                                                    <p className="text-sm text-gray-700">{item.lawFirmName ? "Nome do escritório de advocacia:" : item.lawyerName ? "Nome do advogado:" : "Nome do escritório:"}

                                                                        {item.lawFirmName ? item.lawFirmName : item.lawyerName ? item.lawyerName : "Não informado"}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            item.haveUpdates ?
                                                                <button className="flex items-center justify-center " onClick={() => getProcessoPagina(item.process_id)}>
                                                                    <span className="bg-blue-500 text-white p-2 rounded mt-2 flex  hover:shadow-lg">
                                                                        <MagnifyingGlassCircleIcon className="h-5 w-5 mr-2" />
                                                                        <p>Ver atualizações</p>
                                                                    </span>
                                                                </button> :
                                                                <div className="flex items-center justify-center ">
                                                                    <span className="bg-gray-500 text-white p-2 rounded mt-2 flex  hover:shadow-lg">
                                                                        <p>Sem atualizações</p>
                                                                    </span>
                                                                </div>
                                                        }
                                                    </div>
                                                </>
                                            )
                                        }) : <p className="text-sm text-gray-700">Nenhum processo encontrado</p>
                                    }
                                </p >
                                {
                                    (states.limitSearchJuridico === false && states.dataJuridico.length >= states.limitJuridico) && states.dataJuridico.length > 0 && (
                                        <div className="mt-4 flex justify-center">
                                            <button
                                                onClick={() => {
                                                    setters.setOffsetJuridico(states.offsetJuridico + states.limitJuridico)
                                                }}
                                                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg mt-2 transition-colors duration-200 font-medium"
                                            >
                                                Carregar mais
                                            </button>
                                        </div>
                                    )
                                }
                            </div>
                        </div>




                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}


export default Juridico